// src/config/remoteEnv.ts

export interface RemoteEnv {
  appId: string;
  appName: string;
  region: string;
  theme: string;
  themeOverrideAccentColor: string;
  themeOverrideNavbarColor?: string;
  themeCustom?: Record<string, string>;
  appType?: string;
  menuOnly: boolean;
  fullCatalogueView: boolean;
  countryCode: string;
  currencyCode: string;
  currencySymbol: string;
  stripeTestKey: string;
  stripeLiveKey: string;
  restaurantData?: Record<string, RestaurantData>;
  logoUrl?: string;
  appIconUrl?: string;
  homeStoreUrl?: string;
  terms?: string;
  privacyPolicy?: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
}

export interface RestaurantData {
  menu: any[];
  menuSettings: any[];
}

let _env: RemoteEnv | null = null;

export const setRemoteEnv = (env: RemoteEnv): void => {
  _env = env;
};

export const getRemoteEnv = (): RemoteEnv => {
  if (!_env) {
    throw new Error(
      "Remote config not loaded yet. Ensure fetchRemoteConfig() has been called and awaited before accessing remoteEnv."
    );
  }
  return _env;
};

export const isRemoteEnvLoaded = (): boolean => _env !== null;

export const getStoreCount = (): number => {
  if (!isRemoteEnvLoaded()) return 0;
  const data = getRemoteEnv().restaurantData;
  return data ? Object.keys(data).length : 0;
};

export const isMultiStore = (): boolean => {
  if (!isRemoteEnvLoaded()) return false;
  return getRemoteEnv().appType === "multi-store";
};

// Single-store = NOT the dedicated multi-store mode AND exactly one store.
// Franchise (count > 1), multi-store, and "config not loaded yet" all return false.
export const isSingleStore = (): boolean =>
  !isMultiStore() && getStoreCount() === 1;